
const HowItWorks = () => {
  const steps = [
    {
      icon: 'ri-robot-2-line',
      title: 'Artificial Intelligence',
      description: 'Your visitor clicks the call widget icon in the lower right/left hand corner of the website or our artificial intelligence prompts the widget to open at the ideal time.'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'The PopUp',
      description: 'A mobile friendly pop-up prompts them to enter their phone number to request an instant callback or text message from your business. The website visitor can also schedule a call later when it is more convenient for them.'
    },
    {
      icon: 'ri-phone-line',
      title: '14 Second Instant Call Back',
      description: 'If your visitor chooses to be called our software platform calls your business and when your sales team or front desk staff answer the phone they are prompted to claim the call by simply pressing #1 on their phone.'
    },
    {
      icon: 'ri-phone-fill',
      title: 'Instantly Connected',
      description: 'After your staff or sales people accept the call our software automatically initiates a call to your website visitor connecting them within 14 seconds. Increasing conversion and improving customers experience.'
    },
    {
      icon: 'ri-message-2-line',
      title: 'Two-Way Text Messaging',
      description: 'If your visitor choses to be contacted via text message your are immediately notified of new incoming messages. You have access to a simple dashboard to send, receive, and manage text message conversations online or on the go. Engage with your customers faster with two-way text messaging and close the deal.'
    }
  ];

  return (
    <section id="how-it-works" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our intelligent system connects you with your website visitors in seconds
          </p>
        </div>

        <div className="space-y-12">
          {steps.map((step, index) => (
            <div 
              key={index}
              className="flex flex-col md:flex-row items-start gap-6 p-8 bg-gradient-to-br from-gray-50 to-white rounded-2xl border border-gray-100 hover:shadow-xl transition-all duration-300"
            >
              <div className="flex-shrink-0">
                <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center shadow-lg">
                  <i className={`${step.icon} text-3xl text-white`}></i>
                </div>
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-sm font-bold text-orange-500 bg-orange-50 px-3 py-1 rounded-full">
                    Step {index + 1}
                  </span>
                  <h3 className="text-2xl font-bold text-gray-900">
                    {step.title}
                  </h3>
                </div>
                <p className="text-lg text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a
            href="https://calendly.com/instavisible/30min"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-500 to-orange-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:from-orange-600 hover:to-orange-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <span>See It In Action</span>
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
